import { useNavigate } from "react-router-dom";
import { useAuth } from "@/auth/useAuth";
import { ArrowRight } from "lucide-react";
import { useContext } from "react";
import { NewsletterContext } from "../context/NewsletterContext";
import { useNewsletterConfig } from "../hooks/useNewsletterConfig";
export const FinishSetup = () => {
  const { config, updateIsActive, preview } = useContext(NewsletterContext); // Get config from context
  const { topics, tone, toneFeedback, frequency, preferredDay, isActive } =
    config;
  const { session } = useAuth();
  const email = session?.user.user_metadata.email;
  const navigate = useNavigate();
  const { saveNewsletterConfig } = useNewsletterConfig();
  // const BACKGROUND_COLOR = "bg-gradient-to-r from-slate-200 to-gray-200";
  // const SECONDARY_COLOR = "bg-gradient-to-r from-gray-50 to-slate-50";

  return (
    <div className="max-w-xl mx-auto w-full p-4">
      <div className="bg-gradient-to-r from-indigo-50 to-pink-50 p-6 border border-black rounded-xl shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] ">
        {/* Header */}
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-bold">Your AI Newsletter</h2>
          {typeof isActive !== "undefined" && (
            <div className="flex items-center gap-2">
              <div className="relative inline-flex items-center">
                <div
                  className={`w-12 h-6 ${
                    isActive ? "bg-green-500" : "bg-gray-300"
                  } rounded-full shadow-inner`}
                ></div>
                <div
                  className={`absolute w-5 h-5 bg-white rounded-full shadow left-0.5 top-0.5 transform ${
                    isActive ? "translate-x-6" : "translate-x-0"
                  } transition`}
                ></div>
                <input
                  type="checkbox"
                  className="absolute w-full h-full opacity-0 cursor-pointer"
                  checked={isActive}
                  onChange={async (e) => {
                    const newValue = e.target.checked;
                    console.log("1. Checkbox value:", newValue);
                    console.log("2. Current isActive before update:", isActive);

                    try {
                      // First update the UI and wait for next render
                      updateIsActive(newValue);

                      // Wait for state to be updated
                      await new Promise((resolve) => setTimeout(resolve, 0));

                      // Then save to the database with the new isActive value
                      await saveNewsletterConfig(preview, newValue);
                      console.log("Save successful");
                    } catch (error) {
                      // If save fails, revert the UI
                      console.error("Failed to save:", error);
                      updateIsActive(!newValue);
                    }
                  }}
                />
              </div>
              <span className="text-sm font-medium">
                {isActive ? "Active" : "Inactive"}
              </span>
            </div>
          )}
        </div>

        {/* Settings List Container */}
        <div className="bg-white p-6 rounded-lg border border-black mb-6">
          {/* Topic Setting */}
          <div className="flex items-start mb-6 pb-6 border-b border-gray-200">
            <div className="w-10 h-10 rounded-full mr-4 flex items-center justify-center font-bold text-sm border  bg-white text-black">
              <span>🧠</span>
            </div>
            <div>
              <h3 className="font-semibold text-black text-base">Topics</h3>
              <p className="text-sm text-gray-700 mt-2">
                {topics ? topics.join(", ") : "No topics selected"}
              </p>
            </div>
          </div>

          {/* Tone Setting */}
          <div className="flex items-start mb-6 pb-6 border-b border-gray-200">
            <div className="w-10 h-10 rounded-full mr-4 flex items-center justify-center font-bold text-sm border  bg-white text-black">
              <span>🎨</span>
            </div>
            <div>
              <h3 className="font-semibold text-black text-base">Vibe</h3>
              <p className="text-sm text-gray-700 mt-2">
                <span>{tone}</span>
                {(tone === "Make my own" || tone?.includes("Make my own")) &&
                  toneFeedback && <span className="">: {toneFeedback}</span>}
              </p>
            </div>
          </div>

          {/* Delivery Setting */}
          <div className="flex items-start">
            <div className="w-10 h-10 rounded-full mr-4 flex items-center justify-center font-bold text-sm border  bg-white text-black">
              <span>⏰</span>
            </div>
            <div>
              <h3 className="font-semibold text-black text-base">Schedule</h3>
              <p className="text-sm text-gray-700 mt-2">
                {frequency?.toLowerCase()}, {preferredDay}s to {email}
              </p>
            </div>
          </div>
        </div>

        {/* Footer */}
        <button
          onClick={() => navigate("/dashboard/newsletter/edit")} // Update navigation to edit route
          className="w-full py-4 bg-black text-white text-md font-bold tracking-wide rounded-lg
                    border border-black hover:scale-[1.02] transition-transform"
        >
          <div className="flex items-center justify-center">
            Edit newsletter settings
            <ArrowRight className="ml-2 w-5 h-5" />
          </div>
        </button>
      </div>
    </div>
  );
};
